export default __webpack_public_path__ + "static/media/videocourse.702abfc5.mp4";